import { render, staticRenderFns } from "./trEmotions.vue?vue&type=template&id=20a5a5e3&scoped=true"
import script from "./trEmotions.vue?vue&type=script&lang=js"
export * from "./trEmotions.vue?vue&type=script&lang=js"
import style0 from "./trEmotions.vue?vue&type=style&index=0&id=20a5a5e3&prod&lang=css"
import style1 from "./trEmotions.vue?vue&type=style&index=1&id=20a5a5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5a5e3",
  null
  
)

export default component.exports